import i18next from 'i18next';
import { FeatureFlag, Package } from '@cbo/shared-library';
import routes from '../../../constants/routes';
import { NavItem } from '.';
import { useFeatureFlags } from '../../../utils/hooks/useFeatureFlag';
import { usePackage } from '../../../contexts/packageContext';

export default function useCountingAndLocationRoutes(): NavItem[] {
  const inventoryPackageCore = usePackage(Package.INVENTORY);
  const [inventoryCoreEnabled, mobileInventoryEnabled] = useFeatureFlags(
    FeatureFlag.corePackageInventory,
    FeatureFlag.mobileInventory
  );
  const countingAndLocationsRoutes: NavItem[] = [];

  if (inventoryPackageCore && inventoryCoreEnabled && mobileInventoryEnabled) {
    countingAndLocationsRoutes.push({
      title: i18next.t('navItems.inventoryLists'),
      href: routes.INVENTORY_LISTS,
      testid: 'inventory-lists-summary',
    });

    countingAndLocationsRoutes.push({
      title: i18next.t('navItems.locations'),
      href: routes.LOCATIONS,
      testid: 'locations-summary',
    });

    countingAndLocationsRoutes.push({
      title: i18next.t('navItems.inventoryCount'),
      href: routes.INVENTORY_COUNT_LISTS,
      testid: 'inventory-count',
    });
  }

  return countingAndLocationsRoutes;
}
